import { FormFieldSelectNG } from '../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../Formik'
import { TaskPrioritySelect } from '../TaskPrioritySelect'

function TaskPrioritySelectField(props) {
  return (
    <FormikField
      {...props}
      Component={FormFieldSelectNG}
      Select={TaskPrioritySelect}
      getErrorProps={getFormikFormFieldErrorProps}
    />
  )
}

export default TaskPrioritySelectField
